




import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

@Component
export default class Countdown extends Vue {
    @Prop({ type: Date, default: new Date() }) private end!: Date;
    @Prop({ type: Boolean, default: false }) private withHour!: boolean;

    private now: Date = new Date();
    private withHours: boolean = false;
    private timerId?: number;

    private get hours(): string {
        // @ts-ignore
        let hours: number = Math.trunc((this.end - this.now) / 1000 / 3600);
        return this.formatNumber(hours);
    }

    private get minutes(): string {
        // @ts-ignore
        let minutes: number = Math.trunc((this.end - this.now) / 1000 / 60) % 60;
        return this.formatNumber(minutes);
    }

    private get seconds(): string {
        // @ts-ignore
        let seconds: number = Math.trunc((this.end - this.now) / 1000) % 60;
        return this.formatNumber(seconds);
    }

    private formatNumber(value: number): string {
        return value < 10 ? `0${value}` : ((value as unknown) as string);
    }

    private clearTimer(): void {
        this.timerId && clearInterval(this.timerId);
    }

    private setupWithHours(): void {
        // @ts-ignore
        this.withHours = Math.trunc((this.end - this.now) / 1000 / 3600) > 1;
    }

    @Watch("end", { immediate: true })
    private onEndChanged(newValue: Date, oldValue: Date) {
        this.setupWithHours();
        this.clearTimer();
        this.timerId = setInterval(() => {
            this.now = new Date();
            if (this.now > newValue) {
                this.now = newValue;
                this.clearTimer();
                this.$emit("endTime");
            }
        }, 1000);
    }

    beforeDestroy() {
        this.clearTimer();
    }
}
